export enum MaintenanceComponentTabReferrer {
  Jobs = 'jobs',
  ComponentHistory = 'componentHistory',
  ComponentDetails = 'componentDetails',
  ComponentSpareParts = 'componentSpareParts',
  ComponentProductTypes = 'componentProductTypes',
  Projects = 'projects',
  DeletedJobs = 'deletedJobs',
  DeactivatedJobs = 'deactivatedJobs',
  CompletedOneTimeJobs = 'completedOneTimeJobs',
}
